import React from 'react';
import { sidebarNavItems } from "../../../../../sidebars";
import { NavMenu } from "./NavMenu";
import roomLogo from "../../../../../assets/images/room_logo.png";
import useAppRouter from "../../../../../hooks/useAppRouter";

import {useAuth} from '../../../../../hooks/useAuth';
import {SalesmanType} from "../../../../../enum/user/salesmanType";

export const Sidebar: React.FC = () => {
  const { gotoTopByUser } = useAppRouter();
  const { state: { currentUser } } = useAuth();

  return (
    <>
      <aside className='w-60 min-h-screen bg-gray-800 flex content-center mt-0 top-0 z-10'>
        <div className='w-full'>
            <button
              type="button"
              className="focus:outline-none"
              onClick={() => gotoTopByUser()}
            >
              <div className="flex items-center justify-center mt-10 mb-8">
                <img src={roomLogo} className="w-2/3" alt="icon" />
              </div>
            </button>
            {
              sidebarNavItems.map((item) => {
                if(item.role === 'all' || (item.role === 'admin' && currentUser?.adminFlg === SalesmanType.ADMIN)) {
                  return <NavMenu item={item} key={item.id}/>;
                }
                return '';
              }
            )}
        </div>
      </aside>
    </>
  );
};